import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import useDeviceDetect from "@hooks/useDeviceDetect";
import IconArrow from "@svgs/arrow-up.svg";

function ScrollToTopButton({ containerRef }) {
  const { isMobile } = useDeviceDetect();

  const threshold = isMobile ? 700 : 550;
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const currentRef = containerRef?.current;
    if (!currentRef) return;

    const onScroll = () => {
      const shouldScroll = currentRef.scrollTop >= threshold;
      setHasScrolled((prev) => (prev !== shouldScroll ? shouldScroll : prev));
    };

    currentRef.addEventListener("scroll", onScroll);
    onScroll();

    return () => currentRef?.removeEventListener("scroll", onScroll);
  }, [threshold, containerRef]);

  const handleScrollToTop = () => {
    containerRef?.current?.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    hasScrolled && (
      <div className="fixed right-[30px] bottom-[90px] desktop:bottom-[105px] z-[10]">
        <button
          type="button"
          onClick={handleScrollToTop}
          className="flex flex-col justify-center items-center border border-black rounded-full p-[10px]
                w-[50px] h-[50px] desktop:w-[60px] desktop:h-[60px] bg-white"
        >
          <IconArrow width={isMobile ? "12" : "16"} stroke="#000000" />
          <span className="typo-micro">TOP</span>
        </button>
      </div>
    )
  );
}

ScrollToTopButton.propTypes = {
  containerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
};

export default ScrollToTopButton;
